import storeInit from "storeInit";
import {isEmpty} from "lodash";

export const BSX_PRINTER_AUTH_DEFAULT_ID_KEY = 'bsXPrinterAuthDefaultId'
export default function getDefaultBsxPrinterAuthId(){
  const bsxPrinterAuths = storeInit.getState().bsxPrinterAuths

  if(isEmpty(bsxPrinterAuths)){
    return null
  }else if(bsxPrinterAuths.length === 1){
    return bsxPrinterAuths[0]?.id
  }else if(bsxPrinterAuths.length > 1){
    const localstorageValue = window.localStorage.getItem(BSX_PRINTER_AUTH_DEFAULT_ID_KEY)
    if(localstorageValue) {
      return bsxPrinterAuths.find(({id}) => id === localstorageValue)?.id
    }else{
      updateDefaultBsxPrinterAuthId(null)
    }

    return null
  }

  return null
}

export const updateDefaultBsxPrinterAuthId = (id) => {
  const bsxPrinterAuths = storeInit.getState().bsxPrinterAuths

  if(bsxPrinterAuths.find(bsxPrinterAuth => bsxPrinterAuth.id === id)){
    window.localStorage.setItem(BSX_PRINTER_AUTH_DEFAULT_ID_KEY, id)
  }else{
    window.localStorage.removeItem(BSX_PRINTER_AUTH_DEFAULT_ID_KEY)
  }
}